import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const { lang } = useParams();

    if (loading) return null;

    if (!user) {
        return <Navigate to={`/${lang || 'en'}/login`} replace />;
    }

    return children;
};

export default ProtectedRoute;
